import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "event-actions" }

import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';
import CancelEventDialog from './CancelEventDialog.vue';
import BulkInviteDialog from './BulkInviteDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EventActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

const cancelOpen = ref(false);
const bulkInviteOpen = ref(false);
const busy = ref(false);

const eventId = (): string => String(props.detail.id);

async function doPublish(): Promise<void> {
    if (!window.confirm('Опубликовать сессию?')) return;
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/events/${eventId()}/publish/`,
            data: {},
        });
        onDone();
    } finally {
        busy.value = false;
    }
}

async function doUnpublish(): Promise<void> {
    if (!window.confirm('Снять сессию с публикации?')) return;
    busy.value = true;
    try {
        await request({
            method: 'post',
            url: `/admin-api/events/${eventId()}/unpublish/`,
            data: {},
        });
        onDone();
    } finally {
        busy.value = false;
    }
}

function onDone(): void {
    cancelOpen.value = false;
    bulkInviteOpen.value = false;
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--primary",
      onClick: doPublish
    }, "Опубликовать"),
    _createElementVNode("button", {
      class: "btn",
      onClick: doUnpublish
    }, "Снять с публикации"),
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelOpen.value = true))
    }, "Отменить сессию"),
    _createElementVNode("button", {
      class: "btn btn--primary",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (bulkInviteOpen.value = true))
    }, "Массовые приглашения"),
    (cancelOpen.value)
      ? (_openBlock(), _createBlock(CancelEventDialog, {
          key: 0,
          open: cancelOpen.value,
          "event-id": eventId,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (cancelOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true),
    (bulkInviteOpen.value)
      ? (_openBlock(), _createBlock(BulkInviteDialog, {
          key: 1,
          open: bulkInviteOpen.value,
          "event-id": eventId,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (bulkInviteOpen.value = false)),
          onDone: onDone
        }, null, 8, ["open"]))
      : _createCommentVNode("", true)
  ]))
}
}

})